// extracted by mini-css-extract-plugin
export default {"errorPageContainer":"_404_errorPageContainer__Wjm8u","errorMsg":"_404_errorMsg__DC3kT","homeLink":"_404_homeLink__fwwE9"};